import styled from 'styled-components';
import {FaTimes} from 'react-icons/fa';
import {Link as LinkS} from 'react-scroll';

interface SidebarContainerProps {
    isOpen: boolean;
}

export const SidebarContainer = styled.aside<SidebarContainerProps>`
    position: fixed;
    z-index: 999;
    width: 100%;
    height: 100%;
    background: black;
    display: grid;
    align-items: center;
    top: ${({isOpen}) => (isOpen ? '0' : '-100%')};
    left: 0;
    transition: all 0.2s ease-in-out;
    opacity: ${({isOpen}) => (isOpen ? '100%' : '0%')};
`;

export const CloseIcon = styled(FaTimes)`
    color: #b71b25;
`;

export const Icon = styled.button`
    position: absolute;
    top: 1.2rem;
    right: 1.5rem;
    background: transparent;
    border: 0;
    padding: 0;
    font-size: 2rem;
    cursor: pointer;
    outline: none;
    color: inherit;

    &:focus-visible {
        outline: 2px solid #df2935;
        outline-offset: 4px;
    }
`;

export const SidebarLanguage = styled.div`
    display: flex;
    justify-content: center;
    padding-top: 0.5rem;
`;

export const SidebarWrapper = styled.div`
    color: #fff;
`;

export const SidebarMenu = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, 80px);
    text-align: center;

    @media screen and (max-width: 480px) {
        grid-template-rows: repeat(6, 60px);
    }
`;

export const SidebarLink = styled(LinkS)`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    text-decoration: none;
    list-style: none;
    transition: all 0.2s ease-in-out;
    color: #d9dcd9;
    font-weight: bold;
    cursor: pointer;

    &:hover {
        color: #fff;
    }
`;
